<template>
    <div id="page-dev-buttons">
        <v-container>
            <v-row class="py-8" align="center" justify="center">
                <v-col cols="12" class="text-center">
                    <span class="display-1 font-weight-light">Custom Button</span>
                    <br/>
                    <span class="subtitle-1 font-weight-light deepOrange--text">Custom Button Examples</span>
                </v-col>

              <!-- blue -->
              <v-col cols="12">
                <c-card title="BLUE">
                  <v-row justify="space-around">
                    <c-btn color="blue">default blue</c-btn>
                    <c-btn color="light1Blue">light1 blue</c-btn>
                    <c-btn color="light2Blue">light2 blue</c-btn>
                  </v-row>
                </c-card>
              </v-col>

              <!-- green -->
              <v-col cols="12">
                <c-card title="GREEN">
                  <v-row justify="space-around">
                    <c-btn color="light1Green" @click="onClickGreen">light1 green</c-btn>
                  </v-row>
                </c-card>
              </v-col>

              <!-- red -->
              <v-col cols="12">
                <c-card title="GREEN">
                  <v-row justify="space-around">
                    <c-btn color="red" @click="onClickGreen">red</c-btn>
                    <c-btn color="light1Red" @click="onClickGreen">light1 red</c-btn>
                  </v-row>
                </c-card>
              </v-col>

              <!-- grey -->
              <v-col cols="12">
                <c-card title="GREY">
                  <v-row justify="space-around">
                    <c-btn color="grey">grey</c-btn>
                    <c-btn color="light1Grey">light1Grey</c-btn>
                    <c-btn color="light2Grey">light2Grey</c-btn>
                    <c-btn color="dark3Grey">dark3Grey</c-btn>
                    <c-btn disabled>Disable</c-btn>

                  </v-row>
                </c-card>
              </v-col>



                <!-- EXAMPLE -2 -->
                <v-col cols="12">
                    <c-card title="Size">
                        <v-row justify="space-around">
                            <c-btn color="red" small>Small</c-btn>
                            <c-btn color="green">Default</c-btn>
                            <c-btn color="blue" large>Large</c-btn>
                        </v-row>
                        <v-row justify="space-around">
                            <c-btn color="orange" block>block</c-btn>
                        </v-row>
                    </c-card>
                </v-col>

                <!-- EXAMPLE -3 -->
                <v-col cols="12">
                    <c-card title="Text Button">
                        <v-row justify="space-around">
                            <c-btn color="red" text>Text Button</c-btn>
                            <c-btn color="green" text>Text Button</c-btn>
                        </v-row>
                    </c-card>
                </v-col>

                <!-- EXAMPLE -4 -->
                <v-col cols="12">
                    <c-card title="Icon Button">
                        <v-row justify="space-around">
                            <c-btn color="red" icon iconName="favorite"/>
                            <c-btn color="blue" fab iconName="favorite"/>
                            <c-btn color="blue" iconName="favorite">Button</c-btn>
                        </v-row>
                    </c-card>
                </v-col>

                <!-- EXAMPLE -5 -->
                <v-col cols="12">
                    <c-card title="Outlined">
                        <v-row justify="space-around">
                            <c-btn color="blue" outlined fab icon iconName="favorite"/>
                            <c-btn color="blue" outlined iconName="favorite">Button</c-btn>
                            <c-btn color="blue" outlined>Button</c-btn>
                        </v-row>
                    </c-card>
                </v-col>

                <!-- EXAMPLE -6 -->
                <v-col cols="12">
                    <c-card title="Rounded">
                        <v-row justify="space-around">
                            <c-btn color="blue" rounded iconName="favorite">Button</c-btn>
                            <c-btn color="blue" rounded>Button</c-btn>
                        </v-row>
                    </c-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    data: () => ({
    }),
    methods: {
        onClickRed: function(e) {
            alert('onClickRed')
        },
        onClickGreen: function(e) {
            alert('onClickGreen')
        },
    }
}
</script>
